import React, { useEffect } from "react";

const agent = navigator.userAgent;
const isIphone = agent.indexOf("iPhone") != -1 || agent.indexOf("iPod") != -1;

const useIOSTouch = (elementRef, callback) => {
  useEffect(() => {
    if (elementRef && isIphone) {
      elementRef.current.addEventListener("touchstart", callback, false);
    }
    return () => {
      if (elementRef && isIphone) {
        elementRef.current.removeEventListener("touchstart", callback, false);
      }
    };
  }, [elementRef, isIphone]);
};

export default useIOSTouch;
